import React from 'react';
import { ChevronDownIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function FAQ() {
  return <section className="bg-cream px-4 pb-9 sm:px-6 sm:pb-12" data-id="element-57" data-mp="1mbw54wto8qi1">
      <div className="mx-auto max-w-3xl" data-id="element-58" data-mp="1hdbd3kokpd4o">
        <h2 className="text-xl font-extrabold leading-tight sm:text-3xl" data-id="element-59" data-mp="1he2zq60700it">Questions fréquentes</h2>
        <div className="mt-4 space-y-2" data-id="element-60" data-mp="1cft6i0y139zu">
          {faqs.map(faq => <details key={faq.q} className="group rounded-lg border border-sage/40 bg-white px-4 py-3 [&_summary::-webkit-details-marker]:hidden" data-id="element-61" data-mp="2a2icelvuq6qz">
              <summary className="flex cursor-pointer items-start justify-between gap-3 font-display text-[13px] font-bold uppercase leading-snug text-petrol sm:text-sm" data-id="element-62" data-mp="203jcpst2dlg4">
                {faq.q}
                <ChevronDownIcon aria-hidden="true" className="mt-0.5 h-4 w-4 shrink-0 text-gold transition-transform duration-150 ease-out group-open:rotate-180" data-id="element-63" data-mp="opf8zuwocixv" />
              </summary>
              <p className="mt-2 text-[13px] leading-snug text-graphite/85 sm:text-sm" data-id="element-64" data-mp="1ko9q44szso27">{faq.a}</p>
            </details>)}
        </div>
      </div>
    </section>;
}